import React from 'react';
import { NodeResizer } from 'reactflow';
import { useUIStore } from '@flow-studio/store';

interface NodeResizerFeatureProps {
  selected: boolean;
  minWidth?: number;
  minHeight?: number;
  onResizeEnd: (width: number, height: number) => void;
}

export function NodeResizerFeature({
  selected,
  minWidth = 160,
  minHeight = 60,
  onResizeEnd,
}: NodeResizerFeatureProps) {
  const nodeResizeEnabled = (useUIStore() as any).nodeResizeEnabled as boolean | undefined;

  if (!nodeResizeEnabled) return null;

  return (
    <NodeResizer
      isVisible={selected}
      minWidth={minWidth}
      minHeight={minHeight}
      handleStyle={{
        width: 8,
        height: 8,
        borderRadius: 2,
        background: '#3b82f6',
        border: '1px solid #fff',
      }}
      lineStyle={{
        borderColor: '#3b82f6',
        borderWidth: 1,
        borderStyle: 'dashed',
      }}
      onResizeEnd={(_e: any, params: { width: number; height: number }) =>
        onResizeEnd(params.width, params.height)
      }
    />
  );
}
